module.exports = __webpack_public_path__ + "img/side seam pocket position.d003f22c.png";